module.exports = __webpack_public_path__ + "img/filter 1.77cfb907.svg";